import React from 'react';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Preview } from './components/Preview';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  showUrgency?: boolean;
}
export function App({
  showUrgency = true
}: AppProps) {
  useMetaPixel();
  return <div className="w-full bg-night-800" data-id="element-0" data-mp="2whxb3sqftmf6">
      <main data-id="element-1" data-mp="28tw9l3rof699">
        <Hero data-id="element-2" data-mp="28te1n9vnj3li" />
        <ProofBar data-id="element-3" data-mp="28suumo7jhzm9" />
        <Problem data-id="element-4" data-mp="28sbb5328r364" />
        <Solution data-id="element-5" data-mp="23vcjcr61v8b3" />
        <Preview data-id="element-6" data-mp="23vune9yyeqtk" />
        <Bonuses data-id="element-7" data-mp="23u9u0nodldxa" />
        <Pricing showUrgency={showUrgency} data-id="element-8" data-mp="23utbk3a460as" />
        <Testimonials data-id="element-9" data-mp="3ijxsgzk2wgo4" />
        <Guarantee data-id="element-10" data-mp="3ikr0e3urxc7u" />
        <Faq data-id="element-11" data-mp="3ij668fcdfvai" />
        <FinalCta showUrgency={showUrgency} data-id="element-12" data-mp="3ijpbavgxap74" />
      </main>
      <Footer data-id="element-13" data-mp="3mkrd9k285fcs" />
    </div>;
}